import reduxStore from "../../configureEnvStore";
import { DEVICE_TYPES, ENABLED, ZOOM_LEVEL_LIST } from "../../constants/Constants";
import { AGENTDEFAULTCOLOR, POINTERDEFAULTCOLORS } from "../../constants/LivePointerConstants";
import { PublicVariables } from "../../constants/PublicVariables";
import { setIsLocationOnVideoIsVisible } from "../../reducers/common-reducer";
import { setLivePointerColors, setLivePointerInProgress, setPointerOn } from "../../reducers/livePointer-reducer";
import zoomService from "../../services/zoomService";
import { isAgentIdentity } from "../../shared/utility";
import { getUserDetailsById } from "../Twilio/Room/roomFunction";
import livePointerService from "./livePointerService";

export const toggleFeaturesOnPointerOn = () => {
    if (PublicVariables.isMobile) {
        zoomService.disablePinchZoom();
    }
    reduxStore.dispatch(setIsLocationOnVideoIsVisible(false));
};

export const checkZoomLevelForLivePointerCanvas = (isZoom) => {
    console.log("checkZoomLevelForLivePointerCanvas");

    const canvasContainer = document.getElementById("canvasContainer");
    if (!canvasContainer) return;

    canvasContainer.style.transform = "";

    if (isZoom === "fromZoom") {
        applyZoomTransform(canvasContainer);
    } else {
        console.error("not apply transform scale");
    }
};

const applyZoomTransform = (canvasContainer) => {
    const { currentZoom } = reduxStore.getState().commonReducer;
    const videoElement = document.getElementById("expandedVideo")?.querySelector("video");

    if (!videoElement) return;

    if (PublicVariables.isMobile) {
        canvasContainer.style.transform =
            currentZoom === undefined || currentZoom === ZOOM_LEVEL_LIST.ONE ? "" : `translate(-50%, -50%) scale(${currentZoom})`;
    } else {
        canvasContainer.style.transform = `translate(-50%, -50%) scale(${currentZoom})`;
    }
};

/* - set live pointer colors for all user on join call and participant connect */
export const setLivePointerColorsForAllUser = (identity) => {
    const { livePointerColors } = reduxStore.getState().livePointer || {};
    const pointerObjSize = livePointerColors ? Object.keys(livePointerColors).length : 0;

    if (isAgentIdentity(identity)) {
        // Assign default color for agents
        reduxStore.dispatch(setLivePointerColors({ ...livePointerColors, [identity]: AGENTDEFAULTCOLOR }));
        return;
    }

    if (pointerObjSize === 0) {
        // Assign first default color if no pointers exist
        reduxStore.dispatch(setLivePointerColors({ ...livePointerColors, [identity]: POINTERDEFAULTCOLORS[0] }));
        return;
    }

    if (livePointerColors.hasOwnProperty(identity)) {
        // User already has a color assigned, no action needed
        return;
    }

    // Assign the first available default color not in use
    for (const color of POINTERDEFAULTCOLORS) {
        if (!Object.values(livePointerColors).includes(color)) {
            reduxStore.dispatch(setLivePointerColors({ ...livePointerColors, [identity]: color }));
            break;
        }
    }
};

export const checkLivePointerOn = () => {
    // for multi stream
    const livePointerStatus = livePointerService.getLivePointerFeatureFlagValue();
    const { pointerOn } = reduxStore.getState().livePointer;
    const { isRemoteParticipantJoined, oppScreenshare } = reduxStore.getState().commonReducer;

    if (livePointerStatus == ENABLED && pointerOn && isRemoteParticipantJoined) {
        //turn off local live pointer
        livePointerService.turnOffLivePointer(true);
        if (oppScreenshare) {
            setTimeout(() => {
                livePointerService.disableLivepointer();
            }, 200);
        }
    }
};

export const handleLivepointerOnZoom = () => {
    const { streamingPartiIdentity } = reduxStore.getState().twilioEvents;
    const { pointerOn } = reduxStore.getState().livePointer;
    const userDetails = getUserDetailsById(streamingPartiIdentity);
    if (
        userDetails.device_type == DEVICE_TYPES.ANDROID_BROWSER ||
        userDetails.device_type == DEVICE_TYPES.IOS_BROWSER ||
        userDetails.device_type == DEVICE_TYPES.DESKTOP
    ) {
        if (pointerOn) {
            livePointerService.turnOffLivePointer();
            setTimeout(() => {
                reduxStore.dispatch(setPointerOn(true));
                reduxStore.dispatch(setLivePointerInProgress(false));
                livePointerService.prepareCanvasForLivePointer("0", "fromZoom");
            }, 800);
        }
    }
};
